import { render, staticRenderFns } from "./trill-question.vue?vue&type=template&id=4eac6b42&scoped=true&"
import script from "./trill-question.vue?vue&type=script&lang=ts&"
export * from "./trill-question.vue?vue&type=script&lang=ts&"
import style0 from "./trill-question.vue?vue&type=style&index=0&id=4eac6b42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eac6b42",
  null
  
)

export default component.exports